interface IProps {
  size?: number;
}

export const SearchGradientIcon = ({ size = 14 }: IProps) => {
  return (
    <svg
      viewBox="0 0 14 14"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.607 9.561a5.927 5.927 0 1 0-1.046 1.046l.032.033 3.142 3.143a.74.74 0 1 0 1.048-1.048L10.64 9.593a.806.806 0 0 0-.033-.032ZM9.069 2.783A4.445 4.445 0 1 1 2.783 9.07 4.445 4.445 0 0 1 9.07 2.783Z"
        fill="url(#a)"
      />

      <defs>
        <linearGradient
          id="a"
          x1="0"
          y1="5.5"
          x2="14"
          y2="5.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F76C6C" />
          <stop offset="1" stopColor="#FFA082" />
        </linearGradient>
      </defs>
    </svg>
  );
};
